import posthog from 'posthog-js'
import { Capacitor } from '@capacitor/core'
import { Posthog as PosthogCapacitor } from '@capawesome/capacitor-posthog'

// Generate or retrieve a persistent anonymous distinct ID for session continuity
const getOrCreateAnonymousDistinctId = (): string => {
  const STORAGE_KEY = 'posthog_anonymous_distinct_id'
  
  // Check if we already have an anonymous distinct ID
  let distinctId = localStorage.getItem(STORAGE_KEY)
  
  if (!distinctId) {
    // Generate a new anonymous distinct ID
    // Using a combination of timestamp and random string for uniqueness
    distinctId = `anonymous_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`
    localStorage.setItem(STORAGE_KEY, distinctId)
    console.log('[PostHog] Generated new anonymous distinct ID:', distinctId)
  } else {
    console.log('[PostHog] Using existing anonymous distinct ID:', distinctId)
  }
  
  return distinctId
}

// Initialize PostHog based on platform
if (typeof window !== 'undefined') {
  if (Capacitor.isNativePlatform()) {
    // Initialize PostHog Capacitor plugin for iOS/Android
    PosthogCapacitor.setup({
      apiKey: 'phc_S2o1OCnRfFnQmP1qm10myJhy8xU1bdyb48snZH6A6Co',
      host: 'https://eu.i.posthog.com',
    }).catch((error: unknown) => {
      console.error('[PostHog] Capacitor setup failed:', error)
    })
  } else {
    // Get the anonymous distinct ID for bootstrapping
    const anonymousDistinctId = getOrCreateAnonymousDistinctId()
    
    // Initialize PostHog web SDK for browser
    posthog.init('phc_S2o1OCnRfFnQmP1qm10myJhy8xU1bdyb48snZH6A6Co', {
      api_host: 'https://apiv2.getmoretats.com',
      defaults: '2026-01-30',
      session_recording: {
        recordCrossOriginIframes: false,
      },
      capture_pageview: false,
      capture_pageleave: false,
      autocapture: false, // Prevent automatic DOM event capture before consent
      disable_session_recording: true, // Prevent recording before consent (started explicitly in useConsent)
      persistence: 'localStorage', // Use localStorage to respect user preferences
      // Bootstrap with anonymous distinct ID to ensure session continuity
      // When identify() is called later, PostHog will link this anonymous session to the identified user
      bootstrap: {
        distinctID: anonymousDistinctId,
        isIdentifiedID: false, // This is an anonymous ID, not an identified user
      },
    })
    
    console.log('[PostHog] Initialized with anonymous distinct ID for session linking')
  }
}

export { posthog }